import React, { useCallback } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useDispatch } from 'react-redux';

import Tooltip from '../../General/Tooltip';

import { ClientType } from '../../../Enum/Filters/';
import { Filter } from '../../../Enum/Filters';

import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import { filterChanged } from '../../../Store/Filter/action';

const ClientTypeFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.ClientType);

    const selectClientType = useCallback(
        (clientType: ClientType): void => {
            dispatch(filterChanged(Filter.ClientType, clientType));
        },
        [dispatch],
    );

    return (
        <Form className="client-type-filter" autoComplete="off">
            <Form.Group controlId={Filter.ClientType}>
                <div className="d-flex align-items-center">
                    <Form.Label>Nieuwe klant</Form.Label>
                    <Tooltip
                        title={
                            <>
                                <span className="strikethrough">1,23%</span>: Doorgestreepte tarieven zijn niet
                                beschikbaar voor nieuwe klanten
                            </>
                        }
                    />
                </div>
                <InputGroup>
                    <Form.Check
                        custom
                        checked={value === ClientType.NEW}
                        onChange={() => selectClientType(ClientType.NEW)}
                        type="radio"
                        label="Ja"
                        id="clientTypeFilter1"
                    />
                    <Form.Check
                        custom
                        checked={value === ClientType.EXISTING}
                        onChange={() => selectClientType(ClientType.EXISTING)}
                        type="radio"
                        label="Nee"
                        id="clientTypeFilter2"
                    />
                </InputGroup>
            </Form.Group>
        </Form>
    );
};

export default ClientTypeFilter;
